// A route whose code chunk can't be loaded: reload onto the live build.
//
// Matt, 2026-09-24 (report -P2GQRJNkMlMmQO68BcI): "I hit end and then I made
// some choices and hit start game and instead of loading the game up it just
// put back the banner that said I had a local game and resume didn't work...
// I had to force quit the app." Reproduced exactly (2026-09-26): GameBoard is
// a lazy route chunk named by content hash. A deploy `s3 sync --delete`s the
// old build's GameBoard.<hash>.js, and the new service worker (skipWaiting +
// clientsClaim + cleanupOutdatedCaches) takes over the still-open old page
// and throws away the old precache too. The old page then asks for a chunk
// that exists nowhere, vue-router aborts the navigation, and the lobby just
// sits there - every tap on Start or Resume fails the same way. A force quit
// "fixed" it only because it loaded the new index.html.
//
// So: when a navigation fails on exactly that error, go to the page it was
// headed for with a full reload. Once per target per tab (sessionStorage),
// so a chunk that is genuinely broken on the server can't reload-loop; a
// successful navigation clears the mark.

const RELOAD_KEY = 'thunderstoner:staleChunkReloadFor';

// Chrome, Safari and Firefox each word it differently; Vite's CSS preload
// failure is the fourth shape.
const CHUNK_ERROR = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;

export function isChunkLoadError(error) {
  return CHUNK_ERROR.test(String(error?.message || error || ''));
}

export function shouldReloadFor(target, storage = safeSession()) {
  try {
    if (!storage) return true;
    if (storage.getItem(RELOAD_KEY) === target) return false;
    storage.setItem(RELOAD_KEY, target);
    return true;
  } catch {
    return true;
  }
}

export function clearReloadMark(storage = safeSession()) {
  try {
    storage?.removeItem(RELOAD_KEY);
  } catch {
    // best effort, like every other storage touch in this app
  }
}

function safeSession() {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch {
    return null;
  }
}
